import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'

import * as style from './data-slide.module.scss'
const ChartBarPlot = ({ data, title, inView, legend = [] }) => {
  const ref = useRef(null)

  useEffect(() => {
    const config = {
      width: 680,
      height: 680
    }

    const margin = { top: 24, right: 24, bottom: 80, left: 48 },
      width = config.width - margin.left - margin.right,
      height = config.height - margin.top - margin.bottom

    const svgContainer = d3.select(ref.current)

    svgContainer.selectAll('*').remove()

    const svg = svgContainer
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', [0, 0, width, height])
      .attr('style', 'max-width: 100%; height: auto;')
      .style('width', '100%')

    const xScale = d3
      .scaleBand()
      .domain(data.map((d) => d.category))
      .range([margin?.left, width - margin?.right])
      .padding([0.45])

    const yScale = d3
      .scaleLinear()
      .domain([0, 100])
      .range([height - margin.bottom, margin?.top])

    const color = d3
      .scaleOrdinal()
      .domain(['value1', 'value2'])
      .range(['#ff7f0e', '#1f77b4'])

    const stackedData = d3.stack().keys(['value1', 'value2'])(data)

    svg
      .selectAll('line.grid')
      .data(yScale.ticks(5))
      .enter()
      .append('line')
      .attr('class', style.gridLine)
      .attr('x1', margin?.left)
      .attr('x2', width - margin.right)
      .attr('y1', (d) => yScale(d))
      .attr('y2', (d) => yScale(d))

    const g = svg
      .selectAll('g')
      .data(stackedData)
      .enter()
      .append('g')
      .attr('fill', (d) => color(d.key))

    g.selectAll('rect')
      .data((d) => d)
      .enter()
      .append('rect')
      .attr('x', (d) => xScale(d.data.category))
      .attr('y', (d) => yScale(0))
      .attr('height', (d) => 0)
      .attr('width', xScale.bandwidth())
      .style('font', '400 0.725rem "NotoSans"')

    g.selectAll('text')
      .data((d) => d)
      .enter()
      .append('text')
      .attr('x', (d) => xScale(d.data.category) + xScale.bandwidth() / 2)
      .attr('y', (d) => yScale(d[1]) + (yScale(d[0]) - yScale(d[1])) / 2)
      .attr('text-anchor', 'middle')
      .attr('fill', (d) => {
        return yScale(d[1]) + (yScale(d[0]) - yScale(d[1])) / 2 > height / 2
          ? 'var(--base-000)'
          : 'var(--base-1000)'
      })
      .style('font', '400 0.725rem "NotoSans"')
      .attr('dy', '0.35em')
      .text((d) => {
        const value = d[1] - d[0]
        return value > 0 ? `${value}%` : ''
      })
      .style('opacity', 0)

    // Eje X
    svg
      .append('g')
      .attr('transform', `translate(0, ${height - margin?.bottom})`)
      .call(d3.axisBottom(xScale).tickSize(0).tickPadding(10))
      .call((g) => g.select('.domain').remove())
      .attr('class', style.barPlotXAxis)

    // Eje Y
    svg
      .append('g')
      .attr('transform', `translate(${margin?.left},0)`)
      .call(
        d3
          .axisLeft(yScale)
          .ticks(5)
          .tickFormat((d) => `${d}%`)
          .tickSize(0)
          .tickPadding(10)
      )
      .call((g) => g.select('.domain').remove())
      .attr('class', style.barPlotXAxis)

    const itemWidth = 120

    const colorsByPosition = {
      0: '#ff7f0e',
      1: '#1f77b4'
    }

    if (legend?.length > 0) {
      const legendGroup = svg
        .append('g')
        .attr(
          'transform',
          `translate(${width / 2 - itemWidth},${height - margin.bottom + 48})`
        )

      const legendItem = legendGroup
        .selectAll('.legend')
        .data(legend.map((d) => d))
        .enter()
        .append('g')
        .attr('transform', function (d, i) {
          return `translate(${i * itemWidth},0)`
        })
        .attr('class', 'legend')

      legendItem
        .append('circle')
        .attr('cy', 8)
        .attr('cx', 6)
        .attr('r', 5)
        .attr('fill', function (d, i) {
          return colorsByPosition[i]
        })

      legendItem
        .append('text')
        .attr('x', 18)
        .attr('y', 12)
        .text(function (d) {
          return d
        })
        .attr('class', style.barScatterLegend)
    }

    if (inView) {
      svg
        .selectAll('rect')
        .transition()
        .duration(800)
        .attr('y', (d) => yScale(d[1]))
        .attr('height', (d) => yScale(d[0]) - yScale(d[1]))
        .delay(function (d, i) {
          return i * 100
        })
      svg
        .selectAll('text')
        .transition()
        .duration(800)
        .style('opacity', 1)
        .delay(function (d, i) {
          return i * 100
        })
    }
  }, [inView, legend])

  return (
    <>
      <h4
        className={`b200-bold text-center text-base-000 my-0 ${style.titleGraph}`}
      >
        {title}
      </h4>
      <div ref={ref} />
    </>
  )
}
export default ChartBarPlot
